export const FormFieldSeparator = "___";

export enum FormDisplayWidth {
  FullWidth = "FULL_WIDTH",
  HalfWidthRightAligned = "HALF_WIDTH_RIGHT_ALIGNED",
  HalfWidthLeftAligned = "HALF_WIDTH_LEFT_ALIGNED",
}

export enum FormConsentDropdownValues {
  Yes = "YES",
  No = "NO",
}
